import { Link } from '#components/atoms/link/Link.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import type { TagName } from '#schemas/tag/name.ts';

type Props = Omit<React.ComponentPropsWithRef<typeof Link>, 'to'> & {
  tagName: TagName;
  className?: string;
};

/**
 * Links to the tag's detail page. Attaches `state.from` so EditTagPage returns to the current
 * page after saving, matching RoleLink/RouteLink/NetworkLink; pass `state` to override.
 */
export function TagLink({ tagName, className, children, ...linkProps }: Props) {
  const location = useAppLocation();

  return (
    <Link className={className} to={`/tags/${encodeURIComponent(tagName)}`} state={{ from: location }} {...linkProps}>
      {children ?? tagName}
    </Link>
  );
}
